const zhcn = {
    "Home": "银行首页",
    "Liquidity": "流动资金",
    "Swap": "资产兑换",
    "Stake": "质押获利",
    "Portfolio": "资产总览",
    "Connect Wallet": "连接钱包",
    "Disconnect": "退出钱包",
    "Welcome to TiFi Bank!": "欢迎来到TiFi银行!",
    "The First Decentralized Bank for Allverse": "这里是第一个面向全宇宙的去中心化银行",
    "Exchange Cryptos with other Cryptos": "用加密货币兑换其他的加密货币",
    "GO TO SWAP": "去兑换",
    "Enjoy Earning by Providing Liquidity": "向流动池注入资金，分享利息回报",
    "GO TO LIQUIDITY": "注入资金",
    "Provide Observerbility of Pool Portfolio": "总览各个流动资金池",
    "GO TO PORTFOLIO": "去看看",
    "We appeciate for any feedbacks, please submit your feedbacks": "我们真诚的感谢您的任何反馈，您可以在这里提交反馈意见",
    "here": "点击这里",
    ", and you will have a chance to get TIFI airdrop!": "，您就有机会获得TIFI空投奖励！",
    "Haven’t got a crypto wallet yet?": "还不知道怎么用加密货币钱包？",
    "Learn How to Connect": "了解一下怎么用！",
    "More": "其他钱包",
    "Price Chart": "价格走势图",
    "The market price chart from public exchanges. It shows the historical prices and the latest price in the chart may not be the same as the price show on the right panel of the page. The data chart may be incomplete due to data source provider.": "该走势图基于公开数据源显示了历史数据和当前价格，由于数据的实时性，该图上的价格可能和右边显示的价格略有不同。由于公共数据源的问题，该走势图数据可能会不完整。",
    "24H": "24小时",
    "7D": "7天",
    "14D": "14天",
    "30D": "30天",
    "1Y": "一年",
    "Term of Use": "使用条款",
    "Privacy Policy": "隐私条款",
    "Cookies Policy": "Cookie条款",
    "Disclaimer": "免责声明",
    "FAQ": "常见问题",
    "Contact Us": "联系我们",
    "All rights reserved.": "保留所有权利",
    "Balance": "余额",
    "The number is invalid, maybe too big?": "不是有效的数字，是不是太大了？",
    "You are not on the BSC main net. Please switch to the main net.": "您没有连上币安智能链（BSC），请连接。",
    "You have selected the same tokens, please select a different token.": "您选了两个一样的币，请选择不同的币。",
    "The pair doesn't exist, please select another pair.": "资金池不存在，请选择其他的加密货币配对。",
    "Not enough balance for the transaction.": "非常抱歉，您的余额不足以完成这次交易。",
    "Transaction rejected by user.": "您拒绝了这次交易。",
    "Transaction Submitted!": "交易已提交！",
    "Check Transaction on BSCScan": "在BSCScan上查看该交易。",
    "Swap Success!": "兑换成功！",
    "Approved, now you can swap!": "成功批准，您现在可以兑换了！",
    "Approval Request submitted. Please hold on.": "申请批准已提交，请稍候。",
    "successful added": "添加成功",
    "added failed": "添加失败",
    "Cannot find address of": "无法找到该币的地址：",
    ", have you connected MetaMask?": "，请连接到MetaMask。",
    "copied": "已拷贝！",
    "Price": "价格",
    "per": "每",
    "Price Impact Too High": "该交易对价格的影响太高！",
    "Insufficient Liquidity for This Trade": "没有足够的资金完成该交易！",
    "Insufficient Balance": "余额不足！",
    "Swap Fee": "兑换交易手续费",
    "Swap Fee is 0.2%, where:": "手续费为0.2%，其中：",
    "0.18% is paid to LP Providers": "0.18%付给流动资金的提供者",
    "0.02% to the TiFi treasury": "0.02%为TiFi的项目资金",
    "Price Impact": "该交易对价格的影响",
    "The difference between the market price and estimated price due to trade size.": "根据交易量的大小，预估的价值和目前的市场价值会有所差别。",
    "Route": "兑换路径",
    "Routing through these tokens resulted in the best price for your trade.": "为了以最低价值兑换币，系统找到的最佳兑换路径。",
    "TIFI Sell Fee": "TIFI卖出手续费",
    "There is 2% of fee when selling TIFI, check ": "卖出TIFI时有2%的手续费，请参看",
    "TiFi Token Whitepaper": "TIFI白皮书",
    " for more details.": "以了解更多信息",
    "TIFI Buy Fee": "TIFI买入手续费",
    "There is 1% of fee when buying TIFI, check ": "买入TIFI时有1%的手续费，请参看",
    "Swap from": "您想用什么币兑换？",
    "Swap to": "您想兑换成什么币？",
    "Select the first token": "请选择第一个币",
    "Select the second token": "请选择第二个币",
    "Only tokens that paired with ": "只有和",
    " are listed": "有配对的币会列出来",
    "The following tokens are listed in TiFi Bank": "TiFi银行目前支持以下代币",
    "Stay Tuned!": "敬请期待！",
    "TiFi Bank Portfolio Page will be available in August 2022!": "TiFi银行的资金总览功能会在2022年八月推出！",
    "TiFi Bank Staking will be available in August 2022!": "TiFi银行的质押获利功能会在2022年八月推出！",
    "Your Liquidity": "您提供的流动资金",
    "Connect to a wallet to view your liquidity.": "连接钱包可以查看您提供的流动资金。",
    "Add Liquidity": "添加流动资金",
    "Enter Amount": "请输入金额",
    "Approved! Now you can remove liquidity.": "已批准，现在您可以从池子里移除流动资金！",
    "Liquidity Removal Success!": "您已成功从池子里移除流动资金！",
    "Remove": "移除",
    "liquidity": "流动资金",
    "To receive": "您会收到",
    "and": "和",
    "Amount (LP Tokens to Remove / Total)": "流动资金池代币的数量（要移除的量/总量）",
    "Max": "全部",
    "You will Receive": "您会收到",
    "Pooled": "池子里的",
    "Enable": "批准",
    "Liquidity Pool Token Balance": "流动资金池代币余额",
    "Share of pool": "占资金池的比例",
    "Add liquidity instead": "添加流动资金",
    "No liquidity found": "目前没有流动资金",
    "Approved! Now you can add liquidity.": "已批准，现在您可以向池子里添加流动资金！",
    "Liquidity Provision Success!": "流动资金添加成功！",
    "Tip: By adding liquidity you'll earn 0.18% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.": "提示：向池子中添加流动资金后，您会按持有的资金池比例获得交易量0.18%的奖励，该奖励会根据交易的发生实时积累，您可以在取走资金时获得这些奖励。",
    "Input": "提供",
    "Select a token": "请选择一种币",
    "Price and pool share": "价格和池子占有比例",
    "Insufficent balance": "余额不足",
    "Supply": "提供资金",
    "Connect to a wallet to add liquidity.": "连接钱包以提供流动资金。",
    "Insufficient balance to perform this transaction.": "因余额不足交易无法执行。",
    "Stake TIFI to earn TIFI and WBNB with high APY": "质押TIFI以获得高年利率的TIFI和WBNB回报",
    "Pool Analytics": "流动资金信息",
    "Stake Analytics": "质押获利信息",
    "Your Stake": "您的质押记录",
    "TIFI APY Last 24 Hours": "24小时TIFI年利率",
    "WBNB APY Last 24 Hours": "24小时WBNB年利率",
    "The TIFI APY when staking TIFI based on the transaction of last 24 hours. It is updated every day at 01:00 UTC.": "根据前24小时的交易量计算出的质押TIFI获得TIFI的年利率，该利率每天更新一次，更新时间为格林尼治标准时间凌晨1点。",
    "The WBNB APY when staking TIFI based on the transaction of last 24 hours. This is the APY of average case. It is updated every day at 01:00 UTC.": "根据前24小时的交易量计算出的质押TIFI获得WBNB的年利率，该利率反应了所有质押记录的平均情况，该利率每天更新一次，更新时间为格林尼治标准时间凌晨1点。",
    "TIFI APY Last 30 Days": "30天TIFI年利率",
    "WBNB APY Last 30 Days": "30天WBNB年利率",
    "The average TIFI APY when staking TIFI based on the transaction of last 30 days. It is updated every day at 01:00 UTC.": "根据前30天的交易量计算出的质押TIFI获得TIFI的年利率，该利率每天更新一次，更新时间为格林尼治标准时间凌晨1点。",
    "The WBNB APY when staking TIFI based on the transaction of last 30 days. This is the APY of average case. It is updated every day at 01:00 UTC.": "根据前30天的交易量计算出的质押TIFI获得WBNB的年利率，该利率反应了所有质押记录的平均情况，该利率每天更新一次，更新时间为格林尼治标准时间凌晨1点。",
    "Connect to a wallet to view your stake records.": "请连接钱包以查看质押记录。",
    "Stake TIFI": "质押TIFI",
    "Go to TiFi.net": "访问TiFi.net",
    "TiFi Bank Home Page": "TiFi银行首页",
    "View TIFI on CoinMarketCap": "访问TIFI的CoinMarketCap页面",
    "No stake record found": "找不到您的质押记录",
    "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.": "请注意：TiFi银行对每次质押收取0.02BNB的手续费，提取时不会收手续费。您必须质押TIFI超过30天才能得到利息。您在质押180天后还会得到WBNB利息。",
    "Connect to a wallet to stake.": "请连接钱包开始质押",
    "Staked on": "质押时间",
    "Unstake now, you will get": "现在取出，您会得到",
    ", you will get at least": "，您至少会得到",
    "After": "在此时间之后",
    "Unstake": "取出",
    "Total Amount of TIFI staked on ": "您在该时间质押的TIFI数量 ",
    "TIFI Staked": "质押的TIFI",
    "Reward": "奖励",
    "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!": "注意：因为该质押记录少于180天，因此您不能得到所有的TIFI奖励和WBNB奖励！",
    "Enable Stake": "开启质押功能",
    "Approved! Now you can stake.": "质押功能已开启，您现在可以质押了!",
    "Click on the column name to sort pairs by its volume or APR.": "点击每列的名称，记录会按照流动资金量和年收益率排序。",
    "Pools": "流动资金池",
    "Name": "名称",
    "APY": "年收益率",
    "Action": "添加流动资金",
    "Track the earning trends for staking": "以下图表为质押获利跟踪记录",
    "Stake APY Charts": "质押获利年收益表",
    "TIFI Stake Reward APY": "TIFI质押年收益",
    "TIFI Reflection Reward APY": "TIFI持有奖励(Reflection)年收益",
    "WBNB Stake Reward APY": "WBNB年收益",
    "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.": "注意：TIFI质押年收益表比较了TIFI持有收益（Reflection Reward）和质押收益。两者都取决于交易量，但有更多的交易费作为质押的收益，所以质押会有更多的收益。",
    "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.": "注意：WBNB的收益率表显示的收益是整体的平均情况。您会在质押TIFI 180天之后获得WBNB奖励。",
    "GO TO STAKE": "去质押",
    "Notice: The amounts showing below is based on the rewards TiFi Bank collected so far. It is accumulating as more transactions that will happen on blockchain network.": "请注意：下面显示的代币数量是基于当前TiFi银行的目前收集的奖励计算的，您获得的奖励会随着区块链网络上的交易量不断增长。",
    "The total value of tokens in staking pool, it is updated hourly.": "质押池里所有代币的价值，每小时更新一次",
    "Win": "赢取奖金",
    "Approved! Now you can play Lucky Bags!": "福袋已开启！您现在可以玩了。",
    "Lucky Bags": "福袋",
    "Buy mystery shopping bags and win TIFI!": "买福袋，赢TIFI！",
    "Jackpot": "头奖",
    "The amount TIFI in Jackpot prize pool, bet more and you will have higher chance to win!": "头奖奖池的TIFI数量，投注次数越多，您越有机会获得头奖！",
    "You Have Won": "您已赢得",
    "TiFi Token you have won in total so far.": "您目前已赢得的所有TIFI数量。",
    "Approve to Play!": "开启福袋功能",
    "Select your bet": "请选择投注金额",
    "Rules": "规则",
    "How To Play": "如何玩福袋：",
    "Connect Wallet.": "连接钱包。",
    "Select your bet, it cost from 1x (1 USD worth of TIFI) to 100x (100 USD worth of TIFI).": "选择赌注，赌金从1倍（价值1美元的TIFI）到100倍（价值100美元的TIFI）。",
    "Deposit TiFi Token to your bag, this game will use the token in your bag for bet.": "向您的袋子中存入TIFI, 该游戏会用您袋子中的TIFI作为赌金。",
    "Choose your Lucky Bag from 12 unrevealed bags. The prizes in Lucky Bags are random.": "从12个神秘的购物袋中选择一个福袋。每个福袋都有一定的TIFI奖励，TIFI奖励是随机的。",
    "Win prize on the spot! Everyone has the chance to win Jackpot! Prizes are paid via TIFI.": "等十几秒钟就当场开奖！每个人都有机会得头奖！奖金以TIFI的形式支付到你的钱包。",
    "Bet Amount": "赌注金额",
    "Bets are paid via TIFI, 1x is 1 USD worth of TIFI, 2x is 2 USD worth of TIFI, and so on.": "赌注通过TIFI支付, 1x（一倍）赌注是价值1美元的TIFI，2x（二倍）赌注是价值2美元的TIFI，以此类推。",
    "Here are the bet amounts based on current rate of TIFI:": "这是根据当前TIFI的价格算出的TIFI赌注数量：",
    "Prizes": "奖金",
    "Prizes are reflected in the Balance in Your Bag immediately after your bet. You can withdraw TIFI from your bag to your wallet any time.": "每局结束后奖金会立即存入您的袋子中，您可以在任何时间将您袋子中的TIFI存入您的钱包中。",
    "Usually it takes less than 30 seconds to reveal the prize after you selected the Lucky Bag.": "在您选择福袋之后，通常30秒之内就会揭晓获奖奖项。",
    "There are 6 prizes of Lucky Bags:": "福袋游戏有六种奖项：",
    "Bronze Bag": "铜色袋子",
    "Silver Bag": "银色袋子",
    "Golden Bag": "金色袋子",
    "Sapphire Blue Bag": "蓝宝石袋子",
    "Ruby Red Bag": "红宝石袋子",
    "Win 10% of bet amount.": "奖励赌注金额的10%。",
    "Win 50% of bet amount.": "奖励赌注金额的50%。",
    "Win 200% of bet amount.": "奖励赌注金额的200%。",
    "Win 500% of bet amount.": "奖励赌注金额的500%。",
    "Win 1000% of bet amount.": "奖励赌注金额的1000%。",
    "You will win all TIFI from accumulated Jackpot pool.": "您会赢得头奖奖池中的所有TIFI。",
    "Top Winners!": "获奖排行榜！",
    "Message from Lucky Bag": "福袋消息",
    "Network error, make sure you have internet connection!": "网络错误，请保证您已连接到网络！",
    "Sorry, you don't have sufficient balance to bet!": "抱歉，您没有足够的赌注！",
    "Welcome! Please connect wallet first.": "欢迎！请先连接钱包。",
    "Oops! Something wrong when bet, the TIFI you have paid has been refunded.": "抱歉，下注时出现错误，赌金已返还。",
    "You have selected the bag:": "您选择了下面这个福袋：",
    "Please select your Lucky Bag!": "请您选择福袋",
    "Congratulations!": "恭喜！",
    "You have won a ": "您赢得了一个",
    "Hold on! Your lucky bag will be revealed in a few seconds!": "请稍候，您的福袋将在几秒钟后开奖！",
    "You've won ": "您已经赢得",
    "You are paying ": "您在花费",
    " for a Lucky Bag!": "来购买一个福袋！",
    "Bet again!": "再玩一次！",
    "Lucky Bags Statistics": "福袋数据统计",
    "The statistics about Top Winners and Jackpot Winners": "福袋获奖排行榜和头奖获得者",
    "Play Now!": "去玩福袋！",
    "Total Winners:": "获奖者数量：",
    "Top Winners": "获奖排行榜",
    "Jackpot Prize Pool: ": "头奖奖池:",
    "Jackpot Winners": "头奖获得者",
    "Winner": "获奖者",
    "Total Win ($TIFI)": "总计获得TIFI数量",
    "Jackpot ($TIFI)": "头奖TIFI数量",
    "Winning Date": "获奖日期",
    "No Records Yet.": "暂无记录",
    "Balance in Your Bag": "您袋子中的余额",
    "Click Deposit Button Below to Add TIFI & Play!": "点击下面的“存入”按钮开始！",
    "Deposit": "存入",
    "Withdraw": "取出",
    "Approve the deposit first (no need to do every time), enter the amount and Deposit to Your Bag!": "在钱包里批准向您的袋子中存入TIFI（不需要每次都做），输入金额后点击\"存入您的袋子\"。",
    "You can bet many times as long as there are sufficient TIFI in your bag. If current bet amount is less than the balance in your bag, you have to deposit more TIFI to continue.": "只要您的袋子中有足够的TIFI就可以下注。如果您的一把的赌金大于袋子的余额，您需要向袋子中存入更多的TIFI才能继续玩。",
    "Withdraw Submitted!": "取出请求成功提交！",
    "Withdraw Success!": "取出成功！",
    "Deposit Submitted!": "存入请求成功提交！",
    "Deposit Success!": "存入成功！",
    "Deposit To Your Bag!": "存入您的袋子!",
    "Sorry you don't have enough TIFI for bet, please deposit more TIFI to your bag!": "抱歉，您的赌金余额不足，请向您的袋子中存入更多的TIFI。",
    "Total Amount of TIFI you want to withdraw": "您想取出的TIFI数量",
    "Withdraw To Your Wallet!": "把TIFI取出放到我的钱包里！",
    "TVL in Staking Pool": "质押池资产总价值",
    "Crypto Loan": "加密货币资产借贷",
    "Supply crypto assets to earn interests and get fast loan without credit check.": "提供加密货币资金获取利息，不用查信用快速获得贷款。",
    "Supplied Assets": "提供资金",
    "Total value of your supplied assets.": "您提供的资金总价值。",
    "N/A": "暂无数据",
    "Max. Borrow": "最多可借出价值",
    "This value is estimation of the maximum asset value you can borrow. Because of fluctuated market, you may not be able to borrow so much.": "您可借出资产的总价值。注意：该数据为估计值，由于市场的波动性，您可能无法借出这么多价值的加密货币资产。",
    "Current Borrow": "当前已借出价值",
    "The current value of assets you have borrowed.": "当前您已借出的加密货币资产的价值。",
    "Health Level": "资产健康等级",
    "The health level of your account. You need pay attention to your health level all the time. If your health level is WARNING or UNHEALTHY, you need pay your debts as soon as possible. If health level is UNHEALTHY, you cannot borrow any assets from this platform.": "您的账户的资产健康等级。您需要时刻留意您的资产健康等级，如果您的资产健康状况是“危险”或者“不健康”，您需要尽快偿还您的贷款。如果您的健康状况是“不健康”，您将不能从TiFi银行中贷款。",
    "Connect to a wallet to view assets.": "连接钱包查看资产。",
    "Lending APY": "借出年化收益率",
    "Borrowing APY": "贷款年化收益率",
    "The amount of the tokens in the reserve plus tokens borrowed": "借出和借贷池中加密货币总和",
    "Available": "可借出",
    "The maximum amount of tokens that users can borrow from the pool.": "用户最多可以借出的加密货币数量",
    "Credit": "信用额",
    "The balance of amount of token you have deposited.": "您当前存入的加密货币数量（含利息）。",
    "Debt": "债务额",
    "The balance of the amount of token you have borrowed.": "您借出需要还的的加密货币数量（含利息）",
    "Borrow": "借出",
    "Repay": "还款",
    "No lending pool found": "无法找到贷款资金池",
    "Please connect to wallet first!": "请您先连接钱包！",
    "Borrow Success!": "借款成功！",
    "Borrow Quota": "借款额度",
    "The maxium value of assets you can borrow in the selected token.": "您最多可以借出该加密货币的数量。",
    "Pool Balance": "资金池余额",
    "The current balance in lending pool.": "当前借贷资金池中的余额。",
    "Notice: WBNB is the wrapper token of BNB, you can convert between BNB and WBNB without transaction fee at ": "注意：WBNB是封装BNB的BEP20标准货币，如果您要进行兑换，请",
    "Maximum": "上限",
    "Current Interest Rate:": "当前年化利率：",
    "Exceed the quota": "超出额度",
    "Please go back to select an action you want to take.": "请您返回选择相应的操作。",
    "Deposit Asset": "存入资产",
    "Available in Pool": "资金池余额",
    "Enable Deposit for": "激活存入",
    "Insufficient balance": "余额不足",
    "Repay Success!": "还款成功",
    "Repay Asset": "偿还资金",
    "Enable Repay for": "激活偿还",
    "Withdraw Asset": "提取资金",
    "The borrow or withdraw amount will make your account unhealthy, please try a smaller amount.": "该操作会使您的资产健康等级变为“不健康”，请您减少输入的额度。",
    "Loan": "资产借贷",
    "UNHEALTHY": "不健康",
    "WARNING": "危险",
    "FAIR": "一般",
    "GOOD": "良",
    "VERY GOOD": "优",
    "Assets": "加密货币资产",
    "You can unwrap WBNB for BNB or wrap BNB for WBNB with no trading fees. Exchange rate is always 1 to 1.": "您可以在WBNB和BNB之间进行一比一的无手续费兑换。",
    "Save & Loan": "储蓄借贷",
    "GO TO SAVE & LOAN": "访问储蓄借贷",
    "Circulating Supply": "循环供应",
    "Your TIFI Balance": "您的TIFI余额",
    "TVL": "TVL",
    "Trading Vol. Last 24 Hours": "24小时内交易量",
    "Burnt": "已燃烧",
    "Holders": "持有人",
    "Stake TIFI for 180 days and Receive both TIFI and WBNB Rewards!": "质押TIFI180天以获得高年利率的TIFI和WBNB回报!",
    "Amount to Unstake": "取出数量",
    "Cannot add address of": "无法添加该地址",
    "GO TO PLAY": "玩福袋",
    "GO TO CRYPTO LOAN": "加密借贷",
    "START EARNING": "开始创收",
    "Start Earning!": "开始创收!",
    "Lock To Earn": "锁仓创收",
    "Lock to earn": "锁仓创收",
    "Lock TiFi Token with fix period for high return": "将TiFi币定期锁仓得到高收益率收入。",
    "This exclusive program offers high returns (up to 100% of APR) for locking TiFi Token with fix period.": "该专属方案使您通过定期锁仓TiFi币获得高额回报（高至100%的年收益率）。",
    "Learn more": "了解更多！",
    "TVL in Staking Lock": "锁仓总价值(TVL)",
    "Total TiFi Token Locked": "已锁住TiFi币的总数量",
    "Maximum APR": "最高年回报率",
    "Your Earning Records": "您的创收记录",
    "100 % + Reflection": "100%加上反射奖励",
    "The total value locked in US dollars.": "以美元为单位计算的资产锁仓总价值。",
    "The total amount of TiFi Token locked in staking lock.": "在质押锁中的TIFI总量",
    "The maximum APR you can get, you need follow the terms of lock to earn.": "锁仓创收条款中的最高年回报率。",
    "Connect to a wallet to view your earning records.": "连接钱包以查看创收记录。",
    "Time of Deposit": "存入时间",
    "Time of Maturity": "到期时间",
    "Principal": "本金",
    "Reflection Reward Till Now": "截止目前的反射奖励",
    "Fix Rate Reward": "固定奖励额",
    "You cannot withdraw or change the deposit until the time of maturity.": "在存款到期前您不能取出或者更改。",
    "By clicking the Withdraw button, you will receive ": "取出该存款后，您将会得到",
    "No lock record found": "暂无创收记录",
    "Lock TiFi Token and Earn!": "将TiFi币锁仓来创收！",
    "Earning Terms (Click one row to start)": "创收条款（点击下面的条款开始创收）：",
    "Enable Earning": "同意锁仓创收",
    "Term Period": "期限",
    "Minimum Deposit (TIFI)": "最少存入数量（TIFI）",
    "APR": "年利率",
    "Review Earning Term": "确定创收条款",
    "You are going to deposit TiFi Tokens with the following term:": "您将会以以下条款存入TiFi币：",
    "Deposit Amount: ": "存入数量：",
    "Deposit Period: ": "存入期限：",
    "Days": "天",
    "Reward: ": "创收利率：",
    " and reflection rewards": "加上反射奖励",
    "By clicking the button below, I acknowledged that above terms cannot be changed AND I am not able to withdraw the principal or rewards during the period show above.": "一旦点击下面的按钮，我认可以上条款且该条款不会更改，而且我确定在以上所示的存入期限内我不能取出本金和利息。",
    "Accept and Deposit": "接受并继续",
    "Approved! Now you can start earning.": "已同意，现在您可以锁仓创收了！",
    "Transaction submitted! Please wait a few seconds for completion.": "交易已提交，耐心等待几秒钟后就会完成交易。",
    "Fiat Buy": "银行卡买币",
    "Visa & Mastercard": "银行卡",
    "BUY WITH BANK CARDS": "用银行卡购买",
    "Buy TiFi Token with Visa and Mastercard!": "使用Visa卡和万事达卡买TiFi币！"
}

export default zhcn